import { useEffect, useState } from "react";

import { scrollTo } from "../../common/scrollHelpers.js";
import useScrollYPosition from "../../common/useScrollYPosition.js";
import cx from "classnames";

const propTypes = {};

const BackToTop = (props) => {
  const [visible, setVisible] = useState(false);
  const [scrollYDir, scrollYPos] = useScrollYPosition();

  useEffect(() => {
    const bodyHeight = document.querySelector("body").scrollHeight;
    if (bodyHeight > 2 * window.innerHeight && scrollYPos > bodyHeight / 2) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [scrollYPos]);

  return (
    <div className="back-to-top">
      <div className="back-to-top__container container--100">
        <div>
          {/* {visible && ( */}
          <button
            className={cx("back-to-top__btn", { "--is-visible": visible })}
            aria-label="Scroll to top of page"
            onClick={() => scrollTo({ top: 0 })}
            type="button"
          >
            <svg
              width="33.5"
              height="33.5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 34.68 34.77"
            >
              <circle cx="17.42" cy="17.3" r="16.74" fill="currentColor" />
              <path
                fill="#fff"
                d="M10.65 10.68h13.53v1H10.65zM16.93 14.59h1v10.79h-1z"
              />
              <path
                fill="#fff"
                d="m22.08 19.95-4.65-4.66-4.66 4.66-.7-.71 5.36-5.36 5.36 5.36-.71.71z"
              />
            </svg>
          </button>
          {/*  */}
        </div>
      </div>
    </div>
  );
};

BackToTop.propTypes = propTypes;
export default BackToTop;
